

















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyForm from "@/mixins/form";

import CKEditor from "@/components/ckeditor.vue";
import Rules from "@/components/rules.vue";

@Component({
  components: {
    ckeditor: CKEditor,
    Rules,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() announcementRules!: any[];
  rules: any[] = [];

  mounted() {
    console.log("mounted");
    this.spinLoading = true;
    this.form.setFieldsValue({
      is_all: "1",
    });
    this.rules = this.announcementRules;
    this.spinLoading = false;
  }

  beforeDestroy() {
    console.log("unmounted");
    this.modalVisible = false;
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldsValue) {
              if (_.get(fieldsValue, [key])) {
                const fieldValue = _.get(fieldsValue, [key]);

                if (fieldValue) {
                  if (key === "rules") {
                    _.set(
                      values,
                      [key],
                      JSON.stringify(
                        _.sortBy(fieldValue, (o) => Number(o.rule_sort))
                      )
                    );
                  } else if (moment.isMoment(fieldValue)) {
                    _.set(
                      values,
                      [key],
                      moment(fieldValue).format("YYYY-MM-DD HH:mm:ss")
                    );
                  } else if (_.isArray(fieldValue)) {
                    _.set(values, [key], JSON.stringify(fieldValue));
                  } else {
                    _.set(values, [key], fieldValue);
                  }
                }
              }
            }
            const res = await this.$store.dispatch("announcement/add", {
              ...values,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
